import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grow, Link, List, ListItem, Typography } from '@material-ui/core';
import { createStyles, StyledComponentProps, Theme, withStyles } from '@material-ui/core/styles';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../assets/orderSuccess-lottie.json';
import { transl } from '../../main/transl';
import { mg } from '../../mg/mg';
import { getOmnistore } from '../../stores/Omnistore';
import { OrderResultDialogStore } from './OrderResultDialogStore';

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props: TransitionProps, ref) => <Grow {...props} ref={ref}/>);

const styles = (theme: Theme) => createStyles({
	root: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	error: {
		color: '#FF0000',
	},
	paper: {
		width: '100%',
		height: '100%',
		flex: 1,
		display: 'flex',
	},
	content: {
	},
	item: {
		display: 'list-item',
		listStyle: 'disc inside',
	},
	title: {

	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
	resultText:{
		textAlign:'center',
		fontSize:'1.12rem',
		padding:'20px',
		paddingBottom: '0px'
	},
	linkAction:{
		color: '#000',
		cursor: 'pointer'
	},
	contentButton: {
		width: 'auto',
		textAlign: 'center',
		margin: '40px auto',
		paddingBottom:'40px',
		'& button': {
			backgroundColor: '#ce0058',
			color: 'white',
			borderRadius: '10px',
			'& .MuiTypography-h5': {
				padding: '0px 60px',
				fontSize: '2.5rem',
				fontWeight: 700,
				lineHeight: 1,
				fontFamily: 'TT Hoves Bold'
			}
		},
		'& .MuiButton-contained:hover': {
			backgroundColor: '#a40045'
		}
	},
	emptyCartDialog:{
		'& .MuiDialog-paper':{
			maxWidth: '270px'
		}

	}
});

interface IOrderResultDialogProps {
	store: Instance<typeof OrderResultDialogStore>
}

@observer class _OrderResultDialog extends React.Component<IOrderResultDialogProps & StyledComponentProps> {
	static _lottieOptions = {
		loop: false,
		autoplay: true,
		animationData,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		},
	}

	static _lottieStyle = {
		display: 'flex',
		margin: '20px auto',
		width: '50%',
		overflow:'unset',
		height: 'auto',
	}

	_setOrdePage(close){
		close();
		getOmnistore().locationStore.setPage('OrderPage');
	}

	_btnClick(close) {
		close();
		getOmnistore().locationStore.setPage('LTemplates');
	}

	_close = () => {
		const store = this.props.store;
		if (~store.errors.indexOf('emptyCart')) getOmnistore().locationStore.setPage('LTemplates');
		store.close();
	}

	_renderDialogContent() {
		const classes = this.props.classes || {};
		const {orders, close} = this.props.store;

		if (!orders.length) return null;

		const oBranchName = orders[0]?.branchName || '';
		const oId = orders[0]?.id || '';
		const oSupplierName = orders[0]?.supplierName || '';

		return <>
			<Lottie options={_OrderResultDialog._lottieOptions} style={_OrderResultDialog._lottieStyle}/>
			<div className={classes.resultText}>{transl('order.popup.line1')}</div>
			<div className={classes.resultText} style={{ paddingTop: '0px' }}>
				{transl('order.popup.line2_p1')}
				<strong> {oBranchName} </strong>
				{transl('order.popup.line2_p2')}
				<strong> {oId} </strong>
				{transl('order.popup.line2_p3')}
				<strong> {oSupplierName} </strong>
				{transl('order.popup.line2_p4')}
			</div>
			<div className={classes.resultText}>
				{transl('order.popup.line3_p1')}
				<strong><Link className={classes.linkAction} onClick={() => this._setOrdePage(close)} >{transl('OrderPage')}</Link></strong>
				{transl('order.popup.line3_p2')}
			</div>
			<div className={classes.contentButton}>
				<Button size="large"
					color="default"
					variant="contained"
					onClick={() => this._btnClick(close)}>
					<Typography variant="h5">{transl('ok')}</Typography>
				</Button>
			</div>
		</>;
	}

	_renderErrors() {
		const classes = this.props.classes || {};
		let errors: Array<string> = this.props.store.errors;
		if (~errors.indexOf('notAllowed')) errors = ['notAllowed'];
		return <Dialog open={true} onClose={this._close}>
			<DialogTitle>{transl('hint')}</DialogTitle>
			<DialogContent>
				<List>{errors.map(e => <ListItem key={e} className={classes.item}>{transl('order.' + e)}</ListItem>)}</List>
			</DialogContent>
			<DialogActions><Button onClick={this._close} color="primary">{transl('ok')}</Button></DialogActions>
		</Dialog>;
	}

	render() {
		const classes = this.props.classes || {};
		const {store} = this.props;
		const {isOpen, close, orders, errors} = store;

		if (errors.length) return this._renderErrors();

		if (orders.length) return <Dialog
			disableEscapeKeyDown
			disableBackdropClick
			open={isOpen}
			onClose={close}
			TransitionComponent={Transition}
			className={classes.root}
			classes={{paper: classes.paper}}
		>
			<DialogTitle className={mg.clsn(classes.title, {[classes.error as any]: errors.length})}>
				{transl('order.' + store.status)}
			</DialogTitle>
			<DialogContent className={classes.content}>
				{this._renderDialogContent()}
			</DialogContent>
		</Dialog>;

		return null;
	}
}

export const OrderResultDialog = withStyles(styles)(_OrderResultDialog);

